import Text from 'components/Text/Text';
import React from 'react';
import { IItemSoftwareUpdate } from 'types';
import { softwareTypes } from 'appConstants';
import classNames from 'classnames';
import style from './Item.module.scss';

interface IItem {
	data: IItemSoftwareUpdate;
	index: number;
}

const Item: React.FC<IItem> = ({ data, index }) => {
	const nameRowClasses = classNames(style.name, style.row);
	const lastUpdateRowClasses = classNames(style.lastUpdate, style.row);
	const updatedByRowClasses = classNames(style.updatedBy, style.row);
	const softwareTypeRowClasses = classNames(style.softwareType, style.row);

	const softwareTypeName = softwareTypes.find((el) => el.id === data.softwareType)?.name || null;

	return (
		<div data-test={`Item-${index}`}>
			<div className={style.container}>
				<Text className={nameRowClasses} translationKey={data.name} withTooltip={true} />
				<Text className={lastUpdateRowClasses} translationKey={data.lastUpdateDate} withTooltip={true} />
				<Text className={updatedByRowClasses} translationKey={data.updateBy} withTooltip={true} />
				<Text className={softwareTypeRowClasses} translationKey={softwareTypeName} withTooltip={true} />
			</div>
		</div>
	);
};

export default Item;
